<div class="info-alert" [ngClass]="{ compact: compact }" *ngIf="message && message.trim() !== ''">
	<fa-icon class="info-alert-icon" [icon]="icons.faInfoCircle"></fa-icon>

	<div class="info-alert-content" *ngIf="useHtml; else plainMessage" [innerHTML]="message"></div>

	<ng-template #plainMessage>
		<div class="info-alert-content">{{ message }}</div>
	</ng-template>
</div>
